import axios from 'axios'
import { configuration as config } from './utils'

export type CountryParameters = {
  lspApproved: boolean
}

export type Country = {
  countryName: string
  countryCode: string
  lspApproved: number
}

export type StatusObject = {
  status: boolean
  message: string | null
  data?: object | null
}

const ERR_MESSAGE = (error) => error.response?.data?.message ?? error.message ?? error.errorMessage

const countries = async (params: CountryParameters | null = null): Promise<StatusObject> => {
  try {
    const query = params?.lspApproved ?? false ? 'lspApproved=true' : ''
    const res = await axios.get(config.BASE_API_URL + `/options/countries?${query}`)
    return { status: true, message: 'successful', data: res.data.countries.filter((c: any) => c.countryCode != 'GBD') }
  } catch (error) {
    return {
      status: false,
      message: ERR_MESSAGE(error),
      data: null,
    }
  }
}
const districtCtv = async (district: any) => {
  try {
    const result = await axios
      .get(config.BASE_API_URL + '/options/districts/' + district)
      .then((response) => response.data.ctv)
    return { status: true, message: 'Success', data: result }
  } catch (error) {
    return {
      status: false,
      message: ERR_MESSAGE(error),
      data: null,
    }
  }
}

const relationships = async () => {
  try {
    const response = await axios.get(config.BASE_API_URL + '/options/relationships')
    return { status: true, message: 'Success', data: response.data.relationships }
  } catch (error) {
    return {
      status: false,
      message: ERR_MESSAGE(error),
    }
  }
}
const fees = async (moduleID: any) => {
  return await axios.get(config.BASE_API_URL + '/options/fees/' + moduleID).then((response) => response.data.fees)
}

export { countries, districtCtv, relationships, fees }
